/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBearRight2 = createReactComponent("outline", "arrow-bear-right-2", "IconArrowBearRight2", [["path", { "d": "M15 3h5v5", "key": "svg-0" }], ["path", { "d": "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-1" }], ["path", { "d": "M4 5l4.5 4.5", "key": "svg-2" }]]);

export { IconArrowBearRight2 as default };
//# sourceMappingURL=IconArrowBearRight2.mjs.map
